import { Typography } from "@material-ui/core";
import { IAuditLogEntry } from "../../../../types";

export const LocationAuditCreate = ({ newData }: IAuditLogEntry) => {
  return <Typography>Created a new Location "{newData.name}"</Typography>;
};

export default LocationAuditCreate;
